/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from "../../state-machine";

import { GET_ANALYTICS_DETAIL } from "../graphql";
import config from "../config/weather.analytics.config.json";
import tableConfig from "../config/activityList.config.json";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { usePolicyId } from "../provider";
import moment from "moment";
import { toHeaderCase } from "js-convert-case";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IWeatherAnalyticsMethods extends IPluginMethodMap {
  getWeatherAnalyticsProps(args: any): Promise<any>;
}

export class WeatherAnalyticsService
  extends AppServiceRequestProcessor
  implements IAgentPlugin {
  readonly methods: IWeatherAnalyticsMethods;

  constructor() {
    super();
    this.methods = {
      getWeatherAnalyticsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    console.log(`args in weather analytics`, args)
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { policyNumber } = usePolicyId();
    try {
      if (client) {
        const res = await client.query({
          query: GET_ANALYTICS_DETAIL,
          variables: {
            input: {
              policyId: policyNumber,
              month:parseInt(args?.month)
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getPolicyAnalytics) {
          return {
            ...config,
            events: this.getEvents(res?.data?.getPolicyAnalytics),
            isEmpty: res?.data?.getPolicyAnalytics?.data?.length === 0 ? true : false,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in getDashboardQuery`, err);
      throw Error(err?.message);
    }
  }

  private getEvents(data: any[]) {
    let _temp: any = [];
    if (Array.isArray(data) && data?.length > 0) {
      data.forEach(ele => {
        if (Array.isArray(ele?.events) && ele?.events?.length > 0) {
          console.log(`date format`,);
          ele?.events.forEach((element: any) => {
            _temp.push({
              id: element?.title,
              date: moment(ele?.date).format("YYYY-MM-DD"),
              title: toHeaderCase(element?.title),
              color: this.getColor(element?.title),
              data: {
                data: this.getModalData(element, ele?.hash),
                numberOfColumns: "2"
              }
            })
          });
        }
      })
    }
    return _temp;
  }

  private getColor(color: string) {
    switch (color) {
      case "Tropical Cyclone Occurred":
        return "#DB111D";
      case "Eligible For Payout":
        return "#2A7E19";
      default: return "#FE601F";
    }
  }

  private getModalData(data: any, id: string) {
    console.log(`Get Modal Data`, data)
    let _tmp: any = [];
    for (const [key, value] of Object.entries(data)) {
      if(key!== "title" && value){
        _tmp.push({
          key: id,
          title: toHeaderCase(key),
          subTitle: value
        })
      }
    }

    if (id) {
      _tmp.push({
        key: id,
        title: "Transaction Receipt",
        subTitle: "View Receipt"
      });
    }
    return _tmp;
  }
}
